/* eslint-disable promise/always-return */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-children-prop */

import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import { useMemo, useState } from 'react';
import { HiPlusSm } from 'react-icons/hi';
import { useSelector } from 'react-redux';
import validator from 'validator';
import { EmailReportData } from '../../../api/reports';
import {
  Button,
  Checkbox,
  InfoLabel,
  Input,
  ModalComponent,
  Select,
} from '../../../common/components';
import { useSetLoading } from '../../../common/hooks/appearance';
import {
  downloadTypesEmail,
  fetchDashboardFilterData,
  fetchMultiSelectData,
} from '../../../utils/constant';
import * as handlers from '../../../utils/handlers';

const EmailModal = ({
  isOpen,
  toggle,
  reportType,
  apiValues,
  dateRangeDiffGreaterthanYear = false,
  bulkIdsPayload,
  isTrustAccountParams,
  selectAll,
  selectDue,
  bulkIdsPayloadUnSelected,
  isTrustItemsParams,
  emailOptions,
  newFilters = false,
}) => {
  const filterData = useSelector((state) =>
    newFilters ? state.filters.dashboardMultiSelectFilters : state.filters.filtersForMultiSelect,
  );
  const defaultFilters = useSelector((state) => state?.filters?.defaultMultiSelectFilters);
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState('');
  const [exportType, setExportType] = useState(null);
  const [newEmail, setNewEmail] = useState('');
  const [emails, setEmails] = useState([]);
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [newCCEmail, setNewCCEmail] = useState('');
  const [ccemails, setCCEmails] = useState([]);
  const [selectedCCEmails, setSelectedCCEmails] = useState([]);
  const [showError, setShowError] = useState(false);

  const fetchFilterDataForAPI = (data) => {
    if (newFilters) return fetchDashboardFilterData(data);
    return fetchMultiSelectData(data, defaultFilters);
  };

  const resetAllFields = () => {
    setLoading(false);
    setErrMsg('');
    setExportType(null);
    setNewEmail('');
    setEmails([]);
    setSelectedEmails([]);
    setNewCCEmail('');
    setCCEmails([]);
    setSelectedCCEmails([]);
    setShowError(false);
    toggle();
  };

  const getOnePortalIdsAndEmails = (bulkIdsPayloadValues) => {
    const onePortalIds = [];
    bulkIdsPayloadValues.forEach((rowData) => {
      if (!onePortalIds.includes(rowData.onePortalId))
        onePortalIds.push({
          onePortalId: rowData.onePortalId,
          email: rowData.email,
        });
    });
    return onePortalIds;
  };

  const handleEmailSending = async () => {
    if (dateRangeDiffGreaterthanYear && exportType === 'pdf') {
      setShowError(true);
    } else {
      try {
        setShowError(false);
        setLoading(true);
        const payload = {
          ...apiValues,
          ...(!isTrustAccountParams && !isTrustItemsParams && fetchFilterDataForAPI(filterData)),
          ...(bulkIdsPayload && {
            bulkOnePortalIds: getOnePortalIdsAndEmails(bulkIdsPayload),
          }),
          ...(selectAll &&
            (!bulkIdsPayload || bulkIdsPayload.length === 0) && {
              notSelectedIds: bulkIdsPayloadUnSelected,
              allSelected: selectAll,
            }),
          ...(selectAll &&
            bulkIdsPayload &&
            bulkIdsPayload.length > 0 && {
              bulkOnePortalIds: getOnePortalIdsAndEmails(bulkIdsPayload),
            }),
          ...(selectDue && {
            notSelectedIds: bulkIdsPayloadUnSelected,
            dueSelected: selectDue,
          }),
          ...(!isTrustItemsParams && { exportType }),
          emailIds: selectedEmails,
          ccEmailIds: selectedCCEmails,
          ...(!isTrustAccountParams &&
            !isTrustItemsParams && {
              timezone: moment.tz.guess(),
            }),
        };

        const response = await EmailReportData(reportType, payload);
        if (response.status === 200) {
          let message = 'Email Sent successfully';
          if (response.data?.data?.msg) {
            message = response.data.data.msg;
          } else if (response.data?.msg && isTrustItemsParams) {
            message = response.data.msg;
          }
          handlers.successHandler({
            message: {
              message,
              title: 'Success',
            },
          });
        } else {
          handlers.apiErrorHandler({ message: 'Network Error' });
        }
        resetAllFields();
      } catch (err) {
        resetAllFields();
        handlers.apiErrorHandler(err);
      }
    }
  };

  const handleSelectAll = (type) => {
    if (type === 'CCList') {
      if (selectedCCEmails?.length === ccemails?.length) {
        setSelectedCCEmails([]);
      } else {
        setSelectedCCEmails([...ccemails]);
      }
    } else if (selectedEmails.length === emails.length) {
      setSelectedEmails([]);
    } else {
      setSelectedEmails([...emails]);
    }
  };

  const handleCheckBoxClick = (type, value) => {
    if (type === 'sendingList') {
      const temp = [...selectedEmails];
      if (!temp.includes(value)) {
        temp.push(value);
      } else {
        const rIndex = temp.indexOf(value);
        temp.splice(rIndex, 1);
      }
      setSelectedEmails(temp);
    } else {
      const temp = [...selectedCCEmails];
      if (!temp.includes(value)) {
        temp.push(value);
      } else {
        const rIndex = temp.indexOf(value);
        temp.splice(rIndex, 1);
      }
      setSelectedCCEmails(temp);
    }
  };

  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);

  const handleKeyDown = (e) => {
    if (e.key === ' ') {
      e.preventDefault();
    }
  };

  const EmailModalGenerator = () => {
    return (
      <div className="Email-modal">
        <div className="Email-heading">
          <InfoLabel label="E-mail Report" />
        </div>
        <p className="Email-sub-heading">
          Add an e-mail whom you would like to send this reports to.
        </p>
        {errMsg && <p className="error-message">{errMsg}</p>}
        {!isTrustItemsParams && (
          <div className="emailmodal-dropdown">
            <Select
              required
              name="exportType"
              formInput={false}
              classNamePrefix="select-dropdown"
              placeholder="Choose The Report Format"
              onChange={(val) => {
                setExportType(val.value);
              }}
              value={[emailOptions || downloadTypesEmail].find(
                (option) => option.value === exportType,
              )}
              options={emailOptions || downloadTypesEmail}
              size="lg"
            />
          </div>
        )}
        <div className="Add-email">
          <Input
            formInput={false}
            size="lg"
            type="email"
            placeholder="Enter the e-mail address"
            value={newEmail}
            onChange={(e) => {
              setNewEmail(e.target.value);
              if (e.target.value === '') {
                setErrMsg('');
              }
            }}
            onKeyDown={handleKeyDown}
          />
          <Button
            color="secondary"
            size="xs"
            className="add-btn"
            style={{ fontSize: '14px' }}
            disabled={!newEmail}
            onClick={() => {
              if (
                newEmail &&
                validator.isEmail(newEmail) &&
                !emails.includes(newEmail) &&
                !ccemails.includes(newEmail)
              ) {
                setEmails([...emails, newEmail]);
                setNewEmail('');
                setErrMsg('');
              } else if (emails.includes(newEmail) || ccemails.includes(newEmail)) {
                setErrMsg('Email Address already Exists.');
              } else {
                setErrMsg('Please Enter Valid Email Address.');
              }
            }}
          >
            <HiPlusSm /> Add
          </Button>
        </div>
        <div className="Add-email">
          <Input
            formInput={false}
            size="lg"
            type="email"
            placeholder="Enter the Cc e-mail address"
            value={newCCEmail}
            onChange={(e) => {
              setNewCCEmail(e.target.value);
              if (e.target.value === '') {
                setErrMsg('');
              }
            }}
            onKeyDown={handleKeyDown}
          />
          <Button
            color="secondary"
            size="xs"
            className="add-btn"
            style={{ fontSize: '14px' }}
            disabled={!newCCEmail}
            onClick={() => {
              if (
                newCCEmail &&
                validator.isEmail(newCCEmail) &&
                !ccemails.includes(newCCEmail) &&
                !emails.includes(newCCEmail)
              ) {
                setCCEmails([...ccemails, newCCEmail]);
                setNewCCEmail('');
                setErrMsg('');
              } else if (ccemails.includes(newCCEmail) || emails.includes(newCCEmail)) {
                setErrMsg('Email Address already Exists.');
              } else {
                setErrMsg('Please Enter Valid Email Address.');
              }
            }}
          >
            <HiPlusSm /> Add
          </Button>
        </div>
        <hr />

        {(emails?.length || ccemails?.length > 0) && (
          <div className="sending-list-div">
            {emails?.length > 0 && (
              <div className="Sending-list">
                <div className="d-flex">
                  <Checkbox
                    simple
                    onChange={() => {
                      handleSelectAll('sendingList');
                    }}
                    label=""
                    checked={selectedEmails.length === emails.length}
                  />
                  <p> Sending List</p>
                </div>
                {emails.map((item) => (
                  <div key={item} className="sending-list-1">
                    <Checkbox
                      simple
                      onChange={() => {
                        handleCheckBoxClick('sendingList', item);
                      }}
                      label=""
                      checked={selectedEmails.includes(item)}
                    />
                    <p className="sending-list-p">{item}</p>
                  </div>
                ))}
              </div>
            )}
            {ccemails?.length > 0 && (
              <div className="Sending-list">
                <div className="d-flex">
                  <Checkbox
                    simple
                    onChange={() => {
                      handleSelectAll('CCList');
                    }}
                    label=""
                    checked={selectedCCEmails.length === ccemails.length}
                  />
                  <p>Cc List</p>
                </div>
                {ccemails.map((item) => (
                  <div key={item} className="sending-list-1">
                    <Checkbox
                      simple
                      onChange={() => {
                        handleCheckBoxClick('CCList', item);
                      }}
                      label=""
                      checked={selectedCCEmails.includes(item)}
                    />
                    <p className="sending-list-p">{item}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
        <div className="email-info-text d-none">
          250 records have been selected for sending Mail
        </div>
        {(emails?.length || ccemails?.length > 0) && <hr />}
        <div className="email-btn-section">
          <div>
            {showError && (
              <span className="error-text">
                please select date range with gap less than a year to email the report in pdf
                format.
              </span>
            )}
            <Button
              disabled={
                !isTrustItemsParams
                  ? !(selectedEmails?.length + selectedCCEmails?.length > 0 && exportType)
                  : !(selectedEmails?.length + selectedCCEmails?.length > 0)
              }
              color="primary"
              size="lg"
              style={{ fontSize: '14px' }}
              className="send-btn"
              onClick={handleEmailSending}
            >
              Send the Reports ({selectedEmails?.length + selectedCCEmails?.length} People)
            </Button>
          </div>
          <Button
            color="#F3F3F3"
            className="btn-close"
            textTransform=""
            style={{ fontSize: '14px' }}
            onClick={resetAllFields}
          >
            Close
          </Button>
        </div>
      </div>
    );
  };

  return (
    <ModalComponent isOpen={isOpen} toggle={toggle} className="EmailModalWrapper">
      {EmailModalGenerator()}
    </ModalComponent>
  );
};

EmailModal.propTypes = {
  isTrustAccountParams: PropTypes.bool,
};

EmailModal.defaultProps = {
  isTrustAccountParams: false,
};

export default EmailModal;
